import './App.css';
import HomePage, {SponsorLoader} from './sites/home/HomePage'
import LoginPage from "./sites/login/LoginPage";
import {useState,useEffect} from "react";
import Cookies from 'js-cookie';
import RegisterPage from "./sites/register/RegisterPage";
import PasswordPage from "./sites/password/PasswordPage";
import {API, Entities} from "./utils/Api";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import Layout from "./components/layout/Layout";
import ConfirmationPage from "./sites/confirmation/ConfirmationPage";
import EventsPage, {EventsLoader} from "./sites/events/EventsPage";
import PresentersPage, {PresentersLoader} from "./sites/presenters/PresentersPage";
import ExhibitorsPage, {ExhibitorsLoader} from "./sites/exhibitors/ExhibitorsPage";
import TicketsPage from "./sites/tickets/TicketsPage";
import ContactPage from "./sites/contact/ContactPage";
import PressPage, {PressLoader} from "./sites/press/PressPage";
import BlogPage from "./sites/blog/BlogPage";
import TicketFormPage from "./sites/tickets/TicketFormPage";
import PresenterPage, {PresenterLoader} from "./sites/presenters/PresenterPage";
import PressArticlePage, {ArticleLoader} from "./sites/press/PressArticlePage";
import {TicketRequestLoader} from "./blocks/ticket/Ticket";
import TicketCallbackPage from "./sites/tickets/TicketCallbackPage";
import NewsletterPage from "./sites/newsletter/NewsletterPage";
import ImpressPage from "./sites/impress/ImpressPage";
import EventInfoPage, {EventInfoLoader} from "./sites/eventinfo/EventInfoPage";
import TicketOverPage from "./sites/ticketover/TicketOverPage";
import GalleryPage, {GalleryPageLoader} from "./sites/gallery/GalleryPage";


/*
<Routes>
    <Route path="/" element={<HomePage login={setLoggedInUser} user={loggedInUser} />} />
    <Route path="/home" element={<HomePage login={setLoggedInUser} user={loggedInUser} />} />
    <Route path="/login" element={<LoginPage login={setLoggedInUser} user={loggedInUser} />} />
    <Route path="/register" element={<RegisterPage login={setLoggedInUser} user={loggedInUser} />} />
    <Route path="/users" element={<UsersPage user={loggedInUser} />} />
    <Route path="/confirmation" element={<ConfirmationPage user={loggedInUser} />} />
    <Route path="/password" element={<PasswordChange />} />
    <Route path="*" element={<PageNotFoundPage />} />
</Routes>
 */

function App() {
    const [loggedInUser,setLoggedInUser] = useState(false);
    const router = createBrowserRouter([

        {
            path: '/',
            element: <Layout />,   // A központi layout, amely tartalmazza a Navbart és az Outletet
            loader: scriptLoader,
            children: [
                { path: '/eventinfo', element: <EventInfoPage/>,
                    loader: EventInfoLoader},
                { path: '', element: <HomePage />,
                    loader:SponsorLoader},          // Gyökérútvonal
                { path: 'fooldal', element: <HomePage /> },      // Főoldal alias
                { path: 'programok', element: <EventsPage />,
                    loader: EventsLoader },

                { path: "eloadok", element: <PresentersPage />,
                    loader: PresentersLoader },
                { path: 'kiallitok', element: <ExhibitorsPage />,
                    loader: ExhibitorsLoader },

                { path: 'impresszum', element: <ImpressPage />,
                    loader: PresenterLoader  },
                { path: 'eloado/:id', element: <PresenterPage />,
                    loader: PresenterLoader  },
                { path: 'lezarult', element: <TicketOverPage/>},
                { path: 'jegyek', element: <TicketOverPage/>},
                { path: 'jegy/:purchaseToken', element: <TicketOverPage/>},
                { path: 'jegyek/megerosit', element:<TicketOverPage/>},
                { path: 'kapcsolat', element: <ContactPage /> },
                { path: 'sajto', element: <PressPage />,
                    loader:PressLoader },
                { path: 'sajto/:slug', element: <PressArticlePage></PressArticlePage>,
                    loader: ArticleLoader},
                { path: 'hirlevel', element: <NewsletterPage /> },

                //Angol url-ek
                { path: 'home', element: <HomePage /> },      // Főoldal alias
                { path: 'events', element: <EventsPage />,
                    loader: EventsLoader },
                { path: "presenters", element: <PresentersPage />,
                    loader: PresentersLoader },
                { path: 'exhibitors', element: <ExhibitorsPage />,
                    loader: ExhibitorsLoader },
                { path: 'impress', element: <ImpressPage />,
                    loader: PresenterLoader  },
                { path: 'presenter/:id', element: <PresenterPage />,
                    loader: PresenterLoader  },
                { path: 'ticket', element: <TicketOverPage/>,
                    loader:TicketRequestLoader  },
                { path: 'ticket/:purchaseToken', element: <TicketOverPage/>,
                    loader: TicketRequestLoader},
                { path: 'ticket/confirm', element: <TicketOverPage/>},
                { path: 'contact', element: <ContactPage /> },
                { path: 'press', element: <PressPage />,
                    loader:PressLoader },
                { path: 'press/:slug', element: <PressArticlePage></PressArticlePage>,
                    loader: ArticleLoader},
                { path: 'newsletter', element: <NewsletterPage /> },
                { path: 'galeria', element: <GalleryPage />, loader: GalleryPageLoader },
                { path: 'gallery', element: <GalleryPage />, loader: GalleryPageLoader }

            ]
        }
    ]);

    function facebookLoader(){
        window.location.href = 'https://www.facebook.com/events/704338862159660';
        return null;
    }

    function userLoader(){
        let data = {};
        let user = Cookies.get('user');
        if(user){user =JSON.parse(user)}
        else{
            Cookies.remove('user');
        }
        data.user = user;
        return data;
    }


    async function scriptLoader() {
        // Segédfüggvény script betöltéséhez
        const loadScript = (src) => {
            return new Promise((resolve, reject) => {
                // Ha a script már betöltődött, ne töltsük be újra
                if (document.querySelector(`script[src="${src}"]`)) {
                    return resolve();
                }

                const script = document.createElement("script");
                script.src = src;
                script.type = "text/javascript";
                script.async = true;

                script.onload = resolve;
                script.onerror = () => reject(new Error(`❌ Nem sikerült betölteni: ${src}`));

                document.body.appendChild(script);
            });
        };

        try {
            await Promise.all([
                await loadScript("/benefitshare/js/jquery.js"),
                await loadScript("/benefitshare/js/vendors.min.js"),
                await loadScript('/benefitshare/revolution/js/jquery.themepunch.revolution.min.js'),
                await loadScript('/benefitshare/revolution/js/jquery.themepunch.revolution.min.js'),
                await loadScript('/benefitshare/revolution/js/jquery.themepunch.tools.min.js'),
                await loadScript('/benefitshare/revolution/js/tp-color-picker.min.js'),
                await loadScript('/benefitshare/revolution/js/extensions/revolution.extension.actions.min.js'),
                await loadScript('/benefitshare/revolution/js/extensions/revolution.extension.carousel.min.js'),
                await loadScript('/benefitshare/revolution/js/extensions/revolution.extension.kenburn.min.js'),
                await loadScript('/benefitshare/revolution/js/extensions/revolution.extension.layeranimation.min.js'),
                await loadScript('/benefitshare/revolution/js/extensions/revolution.extension.migration.min.js'),
                await loadScript('/benefitshare/revolution/js/extensions/revolution.extension.navigation.min.js'),
                await loadScript('/benefitshare/revolution/js/extensions/revolution.extension.parallax.min.js'),
                await loadScript('/benefitshare/revolution/js/extensions/revolution.extension.slideanims.min.js'),
                await loadScript('/benefitshare/revolution/js/extensions/revolution.extension.video.min.js'),
                await loadScript('/benefitshare/revolution/revolution-addons/particles/js/revolution.addon.particles.min.js?ver=1.0.3\'')
            ]);
            console.log("✅ jQuery és Vendors betöltve");
            return true;
        } catch (error) {
            console.error(error);
            throw error;
        }
    }



    function cookieValidator(){
        var cookieUser = Cookies.get('user');
        cookieUser = (cookieUser && JSON.parse(cookieUser))??false;
        if (cookieUser) {
            API.request(Entities.test, {}).then((response) => {
                if (parseInt(response.status) === 1) {
                    setLoggedInUser(cookieUser);
                }
                else {
                    Cookies.remove('user');
                    setLoggedInUser(false);
                }
            });
        }
        else{

            setLoggedInUser(false);
        }
    }

    useEffect( () => {
        cookieValidator();
    }, [setLoggedInUser]);

    return (
                <RouterProvider router={router}></RouterProvider>
    );
}

export default App;
